import React from "react";
import { Wallet } from "lucide-react";
import SolutionPageLayout from "./SolutionPageLayout";

// Pathway 5 (Family E) — Finance, Revenue & Administrative Operations
const FinanceRevenue = () => (
  <SolutionPageLayout
    testId="page-solution-finance-revenue"
    icon={Wallet}
    overline="Pathway · 05 of 07 · Aligned with Family E"
    title="For Finance, Revenue & Administrative Operations"
    headline="Stronger structure across revenue, accrual, collection, accounting, procurement, inventory, assets, vehicles, administrative affairs, legal processes, human resources, and institutional reporting."
    intro={[
      "For internal departments and administrative teams that need stronger structure across revenue, accrual, collection, accounting, procurement, inventory, assets, vehicles, administrative affairs, legal processes, human resources, and institutional reporting.",
      "This pathway supports the operating core of institutions: the teams that keep financial, administrative, procurement, and internal control processes moving.",
    ]}
    supportsOverline="Relevant use cases may include"
    supportsTitle="Where this pathway creates institutional value."
    supports={[
      "Revenue, accrual, collection, and accounting workflows",
      "Procurement and direct purchasing",
      "Inventory and movable asset management",
      "Vehicle and fleet-related records",
      "Administrative affairs and internal service workflows",
      "Legal and contract-related process tracking",
      "HR and staff-related administrative processes where applicable",
      "Meeting management, quality management, and strategic planning",
      "Executive dashboards and financial reporting",
    ]}
    ctaTitle="Bring financial, administrative, and procurement operations into a clearer structure."
    primaryCta={{ label: "Discuss Administrative Operations Pathway", to: "/contact" }}
    secondaryCta={{ label: "View Product Portfolio", to: "/product-portfolio#finance-revenue-procurement" }}
  />
);

export default FinanceRevenue;
